import { useQuery } from "@tanstack/react-query";
import { educationDictionaryService } from "../../services/dictionaries";

export const useEducationDegreesDictionary = () => {
    return useQuery({
        queryKey: ["education", "degrees", "dictionary"],
        queryFn: (): Promise<string[]> => educationDictionaryService.getEducationDegrees(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};

export const useEducationInstitutionsDictionary = () => {
    return useQuery({
        queryKey: ["education", "institutions", "dictionary"],
        queryFn: (): Promise<string[]> => educationDictionaryService.getEducationInstitutions(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
